export const setCookie = (name: string, value: string, days: number): void => {
  if (typeof document === 'undefined') return;
  const dayInMs = 24 * 60 * 60 * 1000;
  const expires = new Date(Date.now() + days * dayInMs).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
};

export const getCookie = (name: string): string | null => {
  if (typeof document === 'undefined') return null;

  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    const raw = parts.pop()?.split(';').shift();
    return raw ? decodeURIComponent(raw) : null;
  }

  return null;
};

export const updateConsent = (statistics: boolean, marketing: boolean) => {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push([
    'consent',
    'update',
    {
      analytics_storage: statistics ? 'granted' : 'denied',
      ad_storage: marketing ? 'granted' : 'denied',
      ad_user_data: marketing ? 'granted' : 'denied',
      ad_personalization: marketing ? 'granted' : 'denied',
    },
  ]);
};
